import clientPortal from "./client-portal";
import digitalStyleGuide from "./digital-style-guide";
import inHouseUxPractice from "./in-house-ux-practice";
import oak from "./oak";
import sitecore from "./sitecore";

const cooperatorCaseStudies = [
  inHouseUxPractice,
  oak,
  digitalStyleGuide,
  clientPortal,
  sitecore,
];

export default cooperatorCaseStudies;
